import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Link,
    CircularProgress
} from '@mui/material';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';
import { reportService } from '../../../services/api';

const MostSearchedTerms = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchData, setSearchData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await reportService.getSearchStats();
                if (response.data.success) {
                    setSearchData(response.data.data.topSearches);
                }
            } catch (error) {
                console.error('Error fetching search data:', error);
                setError('Failed to load search data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleViewDetails = () => {
        navigate('/reports/search-insights');
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        p: 1,
                        border: 1,
                        borderColor: 'divider',
                        borderRadius: 1,
                        boxShadow: 1
                    }}
                >
                    <Typography variant="body2" fontWeight="medium">
                        {label}
                    </Typography>
                    <Typography variant="body2" color="primary">
                        {`Searches: ${payload[0].value}`}
                    </Typography>
                    <Typography variant="body2" color="secondary">
                        {`Match Rate: ${payload[0].payload.matchPercentage}%`}
                    </Typography>
                </Box>
            );
        }
        return null;
    };

    if (loading) {
        return (
            <Card>
                <CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                    <CircularProgress />
                </CardContent>
            </Card>
        );
    }

    if (error) {
        return (
            <Card>
                <CardContent>
                    <Typography color="error">{error}</Typography>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">
                        Most Searched Terms
                    </Typography>
                    <Link
                        component="button"
                        variant="body2"
                        onClick={handleViewDetails}
                        sx={{ textDecoration: 'none' }}
                    >
                        View Details
                    </Link>
                </Box>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={searchData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                            dataKey="term"
                            //tick={{ fontSize: 12 }}
                        />
                        <YAxis 
                            domain={[0, 'auto']}
                            //tick={{ fontSize: 12 }}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar
                            dataKey="count"
                            fill="var(--primary-color)"
                            radius={[4, 4, 0, 0]}
                            barSize={40}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};

export default MostSearchedTerms;